namespace TabAurous {

    @Serenity.Decorators.registerEditor()
    export class CommonRMLookup extends
        Serenity.LookupEditorBase<Serenity.LookupEditorOptions, OMS.SubCategoryDetailsRow> {

        public ItemTypeId: number;
        public ProductTypeId: number;
        public CategoryId: number;
        public SubCategoryId: number;

        constructor(container: JQuery, opt: Serenity.LookupEditorOptions) {
            super(container, opt);
        }

        protected getLookupKey() {
            return OMS.CategoryMasterRow.lookupKey;
        }

        protected getItems(lookup: Q.Lookup<any>) {
            var results = Q.getLookup(OMS.RawMaterialMasterRow.lookupKey);
            
            let items = super.getItems(results);
            if (q.isNumber(this.ItemTypeId)) {

                let filters = {
                    ItemTypeId: [this.ItemTypeId],
                    ProductTypeId: [this.ProductTypeId],
                    CategoryId: [this.CategoryId, 0],
                    SubCategoryId: [this.SubCategoryId, 0],
                };
                
                items = q.Filter(items, filters)
            }              
            return items;
        }

    }

    
}
